import * as React from "react";
import { SherpaHeader } from "../../components/layout/SherpaHeader";
import { SherpaFooter } from "../../components/layout/SherpaFooter";
import { RouteDefinition } from "../../App";
import { DevOpsHome } from "./DevOpsHome";

export const devopsRoutes: RouteDefinition[] = [
    {
        path: "/devops",
        content: () => <DevOpsHome />,
        header: () => <SherpaHeader headerType="Home" />,
        footer: () => <SherpaFooter variant="PathFinderHome" agenticUIOnly />
    }
];
